import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '../environment/environment.service';
import { Response, Environment, FileUpload } from '@viso/core/models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  upload(url, formData) {
    const uploadUrl = `${this.environment.API_URL}${url}`;
    const headers = new HttpHeaders();
    headers.set('Content-Type', null);
    headers.set('Accept', 'multipart/form-data');
    return this.http
      .post<Response<FileUpload>>(uploadUrl, formData, { headers })
  }
}
